var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarmLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40909 0.5H5.04545V1.86364H1.40909V0.5ZM5.04545 2.31818H1.40909V3.68182H5.04545V2.31818ZM1.40906 4.13672H5.04542V5.50036H4.13636V6.40909H2.31818V5.50036H1.40906V4.13672ZM0.5 6.41016H15.5V15.5011H0.5V6.41016ZM1.86365 7.77344H6.86365V10.9553H1.86365V7.77344Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmLine);
export default __webpack_public_path__ + "static/media/icon-alarm-line.f47e015cd01a578d86b424d802ccac3b.svg";
export { ForwardRef as ReactComponent };